export const notificationTypes = {
  info: {
    text: 'text-blue-800 dark:text-blue-400',
    background: 'bg-blue-100 dark:bg-blue-800',
    border: 'border-blue-300 dark:border-blue-800',
    icon: 'fas fa-info-circle'
  },
  danger: {
    text: 'text-red-800 dark:text-red-400',
    background: 'bg-red-100 dark:bg-red-800',
    border: 'border-red-300 dark:border-red-800',
    icon: 'fas fa-exclamation-triangle'
  },
  success: {
    text: 'text-green-800 dark:text-green-400',
    background: 'bg-green-100 dark:bg-green-800',
    border: 'border-green-300 dark:border-green-800',
    icon: 'fas fa-check-circle'
  },
  warning: {
    text: 'text-yellow-800 dark:text-yellow-400',
    background: 'bg-yellow-100 dark:bg-yellow-800',
    border: 'border-yellow-300 dark:border-yellow-800',
    icon: 'fas fa-exclamation-circle'
  },
  dark: {
    text: 'text-gray-800 dark:text-gray-400',
    background: 'bg-gray-100 dark:bg-gray-800',
    border: 'border-gray-300 dark:border-gray-800',
    icon: 'fas fa-moon'
  }
};
